export const baseURL = (env: string, isProxy?: Boolean): string => {
	let ret: string = ''
	if (env === 'prod') {
		ret = 'https://api.tikex.com/'
	} else if (env === 'staging') {
		ret = 'https://api.tikex-staging.com/'
	} else if (env === 'dev') {
		ret = 'https://api.tikex-dev.com/'
	} else if (env === 'local') {
		if (isProxy === true) {
			ret = 'http://localhost:3000/api/'
			ret = 'http://127.0.0.1:8080/'
		} else {
			ret = 'http://127.0.0.1:8080/'
		}
	}
	return ret
}
